import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { GamesSearch } from './search/GamesSearch';
import GamesHeader from '@/pages/games/header/GamesHeader';
import GamesCategoryNav from '@/components/shared/games-category-nav/GamesCategoryNav';
import { useSelector } from 'react-redux';
import { selectGamesSearch } from '@/store/ui/selectors';

function Games(): JSX.Element {
  const intl = useIntl();
  const { searchValue } = useSelector(selectGamesSearch);

  return (
    <div>
      <Helmet>
        <title>LuckyDays - {intl.formatMessage({ id: 'header.games' })}</title>
      </Helmet>
      <Suspense fallback={<div />}>
        <GamesHeader />
        <GamesCategoryNav />
      </Suspense>
      {searchValue && searchValue.length > 0 ? (
        <GamesSearch searchValue={searchValue} />
      ) : (
        <Outlet />
      )}
    </div>
  );
}

export default Games;
